import styles from "./StudioNotFound.module.scss";
import { useStudioNotFound } from "./useStudioNotFound";

/**
 * Shown when the address a visitor opened does not belong to any studio on the platform — the
 * domain is unknown, or the studio behind it was deleted. Rendered outside every provider (see
 * index.tsx), so it must stay self-contained: no router, no context, no API calls.
 */
export const StudioNotFound = () => {
  const { address, plannyWebsiteUrl } = useStudioNotFound();

  return (
    <div className={styles.root}>
      <div className={styles.root_ambience} aria-hidden="true">
        <span className={styles.root_ambience_orb} />
        <span className={styles.root_ambience_orb} />
      </div>

      <main className={styles.root_content}>
        <div className={styles.root_panel}>
          <div className={styles.root_badge} aria-hidden="true">
            <svg viewBox="0 0 48 48" className={styles.root_badge_icon}>
              <path d="M8 20 L12 9 H36 L40 20" />
              <path d="M8 20 Q8 25 13 25 Q18 25 18 20 Q18 25 24 25 Q30 25 30 20 Q30 25 35 25 Q40 25 40 20 Z" />
              <path d="M11 25 V39 H37 V25" />
              <path d="M21 31 Q21 28.5 24 28.5 Q27 28.5 27 31 Q27 33 24 33.5 V35" />
              <circle cx="24" cy="37.4" r="0.6" />
            </svg>
          </div>

          <h1 className={styles.root_title}>Обектът не е намерен</h1>

          <p className={styles.root_subtitle}>
            Обектът, който търсите, не съществува или вече не е част от
            платформата Planny.
          </p>

          <div className={styles.root_address}>
            <span className={styles.root_address_label}>Въведен адрес</span>
            <span className={styles.root_address_value}>{address}</span>
          </div>

          <ul className={styles.root_reasons}>
            <li className={styles.root_reasons_item}>
              <span className={styles.root_reasons_item_number}>1</span>
              <div>
                <p className={styles.root_reasons_item_title}>
                  Адресът е въведен грешно
                </p>
                <p className={styles.root_reasons_item_text}>
                  Проверете дали линкът съвпада точно с този, който сте
                  получили от обекта.
                </p>
              </div>
            </li>
            <li className={styles.root_reasons_item}>
              <span className={styles.root_reasons_item_number}>2</span>
              <div>
                <p className={styles.root_reasons_item_title}>
                  Обектът вече не използва Planny
                </p>
                <p className={styles.root_reasons_item_text}>
                  Обектът може да е спрял работа с платформата.
                </p>
              </div>
            </li>
          </ul>

          <p className={styles.root_hint}>
            Ако сте клиент, моля свържете се директно с обекта.
          </p>

          <a
            className={styles.root_action}
            href={plannyWebsiteUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Към Planny
          </a>
        </div>

        <a
          className={styles.root_footer}
          href={plannyWebsiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Planny"
        >
          <img
            className={styles.root_footer_logo}
            src="/planny-wordmark-color-p.png"
            alt=""
          />
        </a>
      </main>
    </div>
  );
};
